import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.page.html',
  styleUrls: ['./edit-address.page.scss'],
})
export class EditAddressPage implements OnInit {
  @Input() address: any;
  @Input() addresses: any;
  editAddressForm: FormGroup;
  constructor(
    private errorHandlerSRV: ErrorHandlerService,
    private toastSRV: ToastService,
    private loaderSRV: LoaderService,
    public modalController: ModalController,
    private fb: FormBuilder,
    public dataService: DataService,
    public translateService: TranslateService,
  ) { }

  ngOnInit() {
    var ProvID = 0;
    /* Get ID's based on Name start */
    if ('ProvName' in this.address) {
      ProvID = this.addresses['provinces'].find(
        (v) => v.prov === this.address['ProvID']
      ).ProvID;
    }

    this.editAddressForm = this.fb.group({
      label: [this.address.label, [Validators.required]],
      address1: [this.address.address1, [Validators.required]],
      city: [this.address.city, [Validators.required]],
      prov: [ProvID, [Validators.required]],
      postal: [this.address.postal, [Validators.required]],
    });
  }
  onCloseModal() {
    this.modalController.dismiss();
  }
  onSaveChanges() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.saving_address') || 'Saving address...')
    const url = `account/addresses/edit/${this.address.addressID}`;
    const data = this.editAddressForm.value;

    this.dataService.postData(url, data).subscribe({
      next: (data: any) => {
        this.loaderSRV.dismissLoader()
        if (data?.status == 'success') {
          if (data?.message) {
            this.toastSRV.presentToast(data?.message)
          }

          
          this.modalController.dismiss('','refresh');
        } else {
          
          this.errorHandlerSRV.displayErrorMessage(data, true)
        }
      },
      error: err => {
        this.errorHandlerSRV.displayErrorMessage(err, true)
      }

    });
  }
}
